import React from 'react';
import {ActionIcon, Box, Burger, Group, Tooltip, useComputedColorScheme} from '@mantine/core';
import {IconDialpad} from '@tabler/icons-react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import logoBlue from '@/assets/logogovex_blue.png';
import logoWhite from '@/assets/logogovex_white.png';
import UserMenu from '@/components/UserMenu/UserMenu';
import QuickActions from './QuickActions';

interface MobileHeaderProps {
  menuOpened: boolean;
  onToggleMenu: () => void;
  onOpenCpv: () => void;
}

/** Compact top bar used below the `lg` breakpoint (navigation lives in a drawer + bottom bar). */
export default function MobileHeader({ menuOpened, onToggleMenu, onOpenCpv }: MobileHeaderProps) {
  const { t } = useTranslation();
  const colorScheme = useComputedColorScheme('light', { getInitialValueInEffect: true });

  return (
    <Group h="100%" px="md" gap="xs" wrap="nowrap" hiddenFrom="lg">
      <Burger opened={menuOpened} onClick={onToggleMenu} size="sm" aria-label="Menu" />
      <Link to="/sitemap" style={{ display: 'flex' }}>
        <img src={colorScheme === 'dark' ? logoWhite : logoBlue} alt="Govex" height={28} />
      </Link>

      <Box style={{ flex: 1 }} />

      <Group gap="xs" wrap="nowrap" visibleFrom="sm">
        <QuickActions />
      </Group>

      <Tooltip label={t('CPV codes', 'CPV codes')}>
        <ActionIcon variant="default" size="lg" aria-label="CPV codes" onClick={onOpenCpv}>
          <IconDialpad stroke={1.5} />
        </ActionIcon>
      </Tooltip>
      <UserMenu />
    </Group>
  );
}
